import React, { useRef, useState, useEffect } from 'react';
import { Send } from 'lucide-react';
import { Textarea } from '../ui/textarea';

export function ChatPanel({ session, messages, newMessage, connected, typingUser, onTyping, onSend, isProfessional, isUser }) {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  const getChatStatusMessage = () => {
    if (session.status === 'completed') return 'Sessão finalizada';
    return 'Chat disponível quando a sessão iniciar';
  };

  return (
    <div className="card-theraflow h-[500px] flex flex-col" data-testid="chat-area">
      <div className="p-4 border-b border-[#EAE8E3] flex items-center justify-between">
        <h3 className="font-medium text-[#292927]">Chat da Sessão</h3>
        <div className={`flex items-center gap-2 text-sm ${connected ? 'text-[#6B8E7C]' : 'text-[#A0A09A]'}`}>
          <div className={`w-2 h-2 rounded-full ${connected ? 'bg-[#6B8E7C]' : 'bg-[#A0A09A]'}`} />
          {connected ? 'Conectado' : 'Desconectado'}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {session.status !== 'in_progress' ? (
          <div className="flex items-center justify-center h-full text-[#A0A09A]">
            {getChatStatusMessage()}
          </div>
        ) : messages.length === 0 ? (
          <div className="flex items-center justify-center h-full text-[#A0A09A]">
            Nenhuma mensagem ainda. Comece a conversa!
          </div>
        ) : (
          messages.map((msg, idx) => {
            const isMe = (isProfessional && msg.is_professional) || (isUser && !msg.is_professional);
            return (
              <div key={msg.message_id || idx} className={`flex ${isMe ? 'justify-end' : 'justify-start'}`}>
                <div className={`max-w-[70%] rounded-2xl px-4 py-3 ${
                  isMe ? 'bg-[#4A5D4E] text-white rounded-br-md' : 'bg-[#F6EBE6] text-[#292927] rounded-bl-md'
                }`}>
                  <p className="text-sm">{msg.content}</p>
                  <p className={`text-xs mt-1 ${isMe ? 'text-white/70' : 'text-[#A0A09A]'}`}>
                    {msg.sender_name} {msg.created_at ? new Date(msg.created_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : ''}
                  </p>
                </div>
              </div>
            );
          })
        )}
        {typingUser && (
          <div className="text-sm text-[#A0A09A] italic">{typingUser} está digitando...</div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {session.status === 'in_progress' && (
        <div className="p-4 border-t border-[#EAE8E3]">
          <div className="flex gap-3">
            <Textarea
              value={newMessage}
              onChange={onTyping}
              onKeyDown={handleKeyDown}
              placeholder="Digite sua mensagem..."
              className="input-theraflow min-h-[50px] max-h-[100px] resize-none"
              disabled={!connected}
              data-testid="chat-input"
            />
            <button
              onClick={onSend}
              disabled={!connected || !newMessage.trim()}
              className="btn-primary px-4"
              data-testid="send-message-btn"
            >
              <Send className="w-5 h-5" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
